<template>
  <van-popup v-model="showPaySuccess">
    <div class="contain">
      <div class="div-contain">
        <img
          class="img"
          src="../../../assets/img/memberIntegral/pay_success.png"
          alt="支付成功"
          fit="cover" />
      </div>
      <div class="title">支付成功</div>
      <!-- <div class="content">请联系客服，我们会尽快发送商品</div> -->
      <div class="btn-contain">
        <van-button class="sureBtn" round @click="clickSure">确认</van-button>
      </div>
    </div>
  </van-popup>
</template>

<script>
import { Popup } from "vant"
import { f } from "qrcode-vue"

export default {
  name: "paySuccess",
  components: {
    [Popup.name]: Popup
  },
  props: {
    showPaySuccess: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      show: true
    }
  },
  methods: {
    clickSure() {
      this.$emit("update:showPaySuccess", false)
      this.$emit("onSure")
    }
  }
}
</script>

<style lang="less" scoped>
.contain {
  width: 100vw;
  height: 100vh;
  background-color: white;
  .div-contain {
    display: flex;
    justify-content: center;
    justify-items: center;
    .img {
      margin-top: 100px;
      width: 160px;
      height: 127px;
    }
  }
  .title {
    display: flex;
    justify-content: center;
    justify-items: center;
    font-size: 20px;
    font-weight: 700;
    color: #000;
    margin-top: 10px;
    letter-spacing: 2px;
  }
  .content {
    display: flex;
    justify-content: center;
    justify-items: center;
    font-size: 15px;
    font-weight: 500;
    color: rgb(187, 187, 187);
    margin-top: 10px;
  }
  .btn-contain {
    display: flex;
    justify-content: center;
    justify-items: center;
    .sureBtn {
      border: 1px solid rgb(184, 184, 184);
      color: rgb(116, 116, 116);
      font-size: 20px;
      font-weight: 500;
      width: 150px;
      height: 50px;
      border-radius: 25px;
      letter-spacing: 2px;
      margin-top: 70px;
    }
  }
}
</style>
